import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import { Delete, History, Search } from '@mui/icons-material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import DownloadIcon from '@mui/icons-material/Download';
import HtmlIcon from '@mui/icons-material/Html';
import ImageIcon from '@mui/icons-material/Image';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Autocomplete, Box, Button, FormControl, InputLabel, ListItemText, MenuItem, Select, Skeleton, Tab, Tabs, TextField, Typography, styled } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DatePicker } from '@mui/x-date-pickers-pro';
import axios from 'axios';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FloatingBackButton from '../../components/FloatingBackButton';
import FloatingSaveButton from '../../components/FloatingSaveButton';
import Colors from '../../library/Colors';
import SftGlobalData from '../../library/SftGlobalData';
import './rma.css';

const brokenImage = "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";

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div style={{ paddingTop: 15 }} className='rowContainerBetween'>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const StyledModal = styled(ModalUnstyled)`
    position: fixed;
    text-align: center;
    z-index: 1300;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    `;

const Backdrop = styled('div')`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    `;

const style = {
    border: '0px solid #000',
    borderRadius: 6,
    p: 2,
    px: 4,
    pb: 3,
};

const getReplacementStatus = (stat) => {
    switch (stat) {
        case "35000": return (<span className='green_text'>AVAILABLE</span>);
        case "35001": return (<span className='error_text'>UNAVAILABLE</span>);
        case "35002": return (<span className='error_text'>MISSING</span>);
        case "35003": return (<span className='error_text'>DEFECT</span>);
        case "35004": return (<span className='error_text'>SOLD</span>);
        case "35005": return (<span className='error_text'>DELETED</span>);
        default:
            return (<span className='green_text'>AVAILABLE</span>);
    }
}

const getRmaStatus = (stat) => {
    switch (stat) {
        case "29000": return (<span className='green_text'>OPEN</span>);
        case "29001": return (<span className='green_text'>ARTICLE RECEIVED</span>);
        case "29002": return (<span className='error_text'>PROCESSED</span>);
        case "29003": return (<span className='sft_blue_text'>ARTICLE RETURNING</span>);
        case "29004": return (<span className='sft_blue_text'>REPLACEMENT RETURNING</span>);
        case "29005": return (<span className='error_text'>DELETED</span>);
        default:
            return (<span className='green_text'>OPEN</span>);
    }
}

const getSupplierStatus = (stat) => {
    switch (stat) {
        case "29500": return (<span className='green_text'>OPEN</span>);
        case "29501": return (<span className='sft_blue_text'>CONTACTED</span>);
        case "29502": return (<span className='green_text'>OFFER RECEIVED</span>);
        case "29503": return (<span className='sft_blue_text'>SHIPPED</span>);
        case "29504": return (<span className='green_text'>RETURNED</span>);
        case "29505": return (<span className='error_text'>CLOSED</span>);
        default:
            return (<span className='green_text'>OPEN</span>);
    }
}

const RMADetailScreen = (props) => {
    const [loading, setLoading] = useState(true);
    const [replacements, setReplacements] = useState([]);
    const [value, setValue] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [expanded, setExpanded] = useState('panel0');
    const [statusModal, setStatusModal] = useState(false);
    const [supplierStatusModal, setSupplierStatusModal] = useState(false);
    const [statusRemark, setStatusRemark] = useState("");
    const [history, setHistory] = useState([]);
    const [users, setUsers] = useState([]);
    const [store, setStore] = useState("01");

    // Files
    const [files, setFiles] = useState([]);
    const [filename, setFilename] = useState("");
    const [file, setFile] = useState("");
    const inputFile = useRef();

    // History
    const [modalHistoryRec, setModalHistoryRec] = useState(false);
    const [modalHistoryAdd, setModalHistoryAdd] = useState(false);
    const [historyRec, setHistoryRec] = useState({});

    // Single data
    const [assignedUserId, setAssignedUserId] = useState("1001");
    const [assignedUserName, setAssignedUserName] = useState("_SoftTouch");
    const [barcode, setBarcode] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [id, setId] = useState("0");
    const [kldeId, setKldeId] = useState("0");
    const [klnr, setKlnr] = useState("0");
    const [remark, setRemark] = useState("");
    const [replacementFrom, setReplacementFrom] = useState("");
    const [replacementUntil, setReplacementUntil] = useState("");
    const [replacementId, setReplacementId] = useState("0");
    const [rmaStatus, setRmaStatus] = useState("29000");
    const [serialNumber, setSerialNumber] = useState("");
    const [supplierRmaId, setSupplierRmaId] = useState("");
    const [supplierStatus, setSupplierStatus] = useState("29500");
    const [ticketNr, setTicketNr] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");
    const [warrantyUntil, setWarrantyUntil] = useState("");
    const [selectedFile, setSelectedFile] = useState({});
    const [modalFile, setModalFile] = useState(false);

    // Big data (objects)
    const [customer, setCustomer] = useState({});
    const [deliveryAddress, setDeliveryAddress] = useState({});
    const [replacement, setReplacement] = useState({});
    const [ticket, setTicket] = useState({});
    const [article, setArticle] = useState({});

    // Steps
    const [historyRemark, setHistoryRemark] = useState("");
    const [historyRemarkSupp, setHistoryRemarkSupp] = useState("");

    // Search 
    const [searching, setSearching] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [columns, setColumns] = useState([]);
    const [resultFunc, setResultFunc] = useState(() => (row) => { console.log("How did you get here?"); });
    const [searchTarget, setSearchTarget] = useState("");
    const [deliveryAddresses, setDeliveryAddresses] = useState([]);
    const [ticketDetail, setTicketDetail] = useState([]);

    // Other
    const params = useParams();
    const navigate = useNavigate();
    const inputRepl = useRef();
    const inputFocus = useRef();

    useEffect(() => {
        if(props.api !== "") loadRma();
        //console.log("props", props);
    }, [props.api]);

    useEffect(()=>{
        if(statusRemark !== ""){
            updateStatus();
        }

    },[rmaStatus, supplierStatus])

    const updateStatus = () => {
        let postData = {
            key: props.api,
            id: params.rmaId,
            replacement_id: replacementId,
            rma_status: rmaStatus,
            supplier_status: supplierStatus,
            replacement_from: replacementFrom,
            replacement_until: replacementUntil,
            sft_user: (props?.db?.db_id == 179 ? props?.login?.sft_user_id : ""),
            message: statusRemark
        };
        SftGlobalData.post('rma&action=updateStatus', postData).then(response => {
            if (typeof response.data.succes) {
                props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
                getHistory();
            } else {
                props.notify(props.t('errorOccured') + " " + response.data.message, 7500, "top-center", props.theme, 1);
            }
        });
        setStatusRemark("");
    }

    const uploadFile = () => {
        let postData = { 
            key: props.api, 
            id: params.rmaId,
            file_data: file,
            file_name: filename,
            sft_user: (props?.db?.db_id == 179 ? props?.login?.sft_user_id : ""),

        };
        SftGlobalData.post('rma&action=uploadFile', postData).then(response => {
                setFilename("");
                setFile("");
                loadFiles();
            }
        );
    }

    const loadFiles = () => {
        let postData = { key: props.api, id: params.rmaId };
        SftGlobalData.post('rma&action=files', postData).then(response => {
            setFiles(response.data);
            setLoading(false);
        });
    }

    const onDeleteFile = (fileId) => {
        if (window.confirm(props.t('confirm_delete_document')) === true) {

            setLoading(true);
            let postData = {
                key: props.api,
                rmaId: params.rmaId,
                fileId: fileId
            };
            SftGlobalData.post('rma&action=deleteFile', postData).then(response => {          
                setFiles(response.data);
                setLoading(false);
            });
        }
    }

    const loadUsers = () => {
        let postData = { type: 'allUsers', key: props.api };
        SftGlobalData.post('sftData', postData).then(response => {
            setUsers(response.data);
            loadFiles();
        });
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const loadRma = () => {
        setLoading(true);
        let postData = { key: props.api, id: params.rmaId, compact: false };
        let replacementId = 0;
        SftGlobalData.post('rma&action=fetch', postData).then(response => {
            if (typeof response.error === 'undefined') {
                replacementId = response.data[0].replacement_id;
                setAssignedUserId(response.data[0].assigned_user_id);
                setAssignedUserName(response.data[0].assigned_user_name);
                setBarcode(response.data[0].barcode);
                setCreatedAt(response.data[0].created_at);
                setId(response.data[0].id);
                setKlnr(response.data[0].klnr);
                getDeliveryAddress(response.data[0].klnr);
                setKldeId(response.data[0].klde_id);
                setRemark(response.data[0].remark);
                setReplacementId(response.data[0].replacement_id);
                setReplacementFrom(response.data[0].replacement_from);
                setReplacementUntil(response.data[0].replacement_until);
                setRmaStatus(response.data[0].rma_status);
                setSerialNumber(response.data[0].serial_number);
                setSupplierRmaId(response.data[0].supplier_rma_id);
                setSupplierStatus(response.data[0].supplier_status);
                setStore(response.data[0].mag);
                setTicketNr(response.data[0].ticketnr);
                getTicketDetail(response.data[0].ticketnr);
                setUpdatedAt(response.data[0].updated_at);
                setWarrantyUntil(response.data[0].warranty_until);

                setCustomer(response.data[0].customer);
                setDeliveryAddress(response.data[0].delivery_address);
                setReplacement(response.data[0].replacement);
                setTicket(response.data[0].ticket);
                setArticle({data: response.data[0].data, article: response.data[0].article});
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            if(params.rmaId === "add"){
                if(typeof params?.storeId !== "undefined")
                    setStore(params.storeId);
            }
            getHistory();
            loadReplacements(replacementId);
        });
        props.changeScreen('Licence');
    }

    const loadReplacements = (replacementId) => {
        let postData = { key: props.api, available: true, id: replacementId };
        SftGlobalData.post('rma&action=replacements', postData).then(response => {
            if (typeof response.error === 'undefined') {
                setReplacements(response.data);
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            loadUsers();
        });
        props.changeScreen('Licence');
    }

    const getTabName = () => {
        switch(value){
            case 0: return "RMA detail.";
            case 1: return "replacement.";
            case 2: return "supplier.";
            case 3: return "history.";
            default: return "unknown.";
        }
    }

    const onSave = () => {
        if(klnr !== "" && klnr != "0" && barcode !== "" && barcode != "0"){
            let postData = {
                key: props.api,
                id: params.rmaId,
                klnr: klnr,
                klde_id: kldeId,
                ticketnr: ticketNr,
                barcode: barcode,
                serial_number: serialNumber,
                warranty_until: warrantyUntil,
                replacement_id: replacementId,
                rma_status: rmaStatus,
                supplier_status: supplierStatus,
                supplier_rma_id: supplierRmaId,
                remark: remark,
                assigned_user_id: assignedUserId,
                replacement_from: replacementFrom,
                replacement_until: replacementUntil,
                store: store,
                sft_user: (props?.db?.db_id == 179 ? props?.login?.sft_user_id : ""),
                message: (params.rmaId === "add" ? "Created RMA." : ("RMA saved on " + getTabName()))
            };
            SftGlobalData.post('rma&action=update', postData).then(response => {
                if (response.status == 200) {
                    if(params.rmaId === "add")
                        navigate("/" + props.lang + "/rma/detail/" + response.data.id);           
                    else {
                        props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1); 
                        getHistory();
                    }
                } else {
                    props.notify(props.t('errorOccured') + " " + response.data.message, 7500, "top-center", props.theme, 1);
                }
            });
        } else {
            props.notify("MISSING REQUIRED FIELDS! (Customer and article are required)", 7500, "top-center", props.theme, 1);
        }
    }

    const getTicketDetail = (receiptId) => {
        let payload = { key: props.api, search: receiptId };
        SftGlobalData.post('rma&action=fetchTicketDetail', payload).then(response => {
            if (typeof response.error === 'undefined') {
                try {
                    setTicketDetail(response.data);
                    if (response.data.length === 1) {
                        setBarcode(response.data[0].barcode);
                        setArticle({data: response.data[0], article: response.data[0].barcode});
                    }
                } catch (e) {
                    if (SftGlobalData.debug)
                        console.error(e);
                    setTicketDetail([]);
                }
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
        });
    }

    const getHistory = () => {
        if(params.rmaId !== "add"){
            let payload = { key: props.api, id: params.rmaId };
            SftGlobalData.post('rma&action=fetchHistory', payload).then(response => {
                if (typeof response.error === 'undefined') {
                    setHistory(response.data);
                } else {
                    props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
                }
            });
        }
        
    }

    const getDeliveryAddress = (custno) => {
        let payload = { key: props.api, search: custno };
        SftGlobalData.post('rma&action=fetchDeliveryAddress', payload).then(response => {
            if (typeof response.error === 'undefined') {

                try {
                    setDeliveryAddresses(response.data);
                    if (response.data.length > 0) {
                        setKldeId(response.data[0].klde_id);
                        setDeliveryAddress(response.data[0]);
                    }
                } catch (e) {
                    if (SftGlobalData.debug)
                        console.error(e);
                    setKldeId("0");
                    setDeliveryAddress({});
                }
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
        });
    }

    const search = (filter) => {
        let endpoint = "";
        let payload = { key: props.api, store: store, search: searchVal };
        switch (filter) {
            case "receipts":
                endpoint = "searchReceipts";
                break;
            case "customers":
                endpoint = "searchCustomers";
                break;
            case "articles":
                endpoint = "searchArticles";
                break;
        }
        if (endpoint !== "") {
            setSearching(true);
            SftGlobalData.post(`rma&action=${endpoint}`, payload).then(response => {
                if (typeof response.error === 'undefined') {
                    mapResultData(filter, response.data);
                } else {
                    props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
                }
                setSearching(false);
            });
        }
    }

    const mapResultData = (filter, data) => {
        switch (filter) {
            case "receipts":
                setResultFunc(() => (row) => { if (SftGlobalData.debug) { console.log("row", row); } setTicketNr(row.id); setBarcode(""); setArticle({}); getTicketDetail(row.id); setTicket(row.fullRow); setCustomer(row.fullRow); setKlnr(row.fullRow.klnr); setModalOpen(false); })
                setColumns([
                    {
                        field: 'id',
                        headerName: 'ID',
                        minWidth: 50,
                        width: 120,
                        align: "left",
                    },
                    {
                        field: 'datum',
                        headerName: 'Date',
                        minWidth: 110,
                        maxWidth: 110,
                        width: 110,
                        align: "left",
                    },
                    {
                        field: 'uur',
                        headerName: 'Time',
                        minWidth: 75,
                        maxWidth: 75,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'mag',
                        headerName: 'Store',
                        minWidth: 75,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'kassa_id',
                        headerName: 'POS',
                        minWidth: 75,
                        maxWidth: 75,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'naam',
                        headerName: 'Last name',
                        minWidth: 150,
                        width: 150,
                        align: "left",
                    },
                    {
                        field: 'firstname',
                        headerName: 'First name',
                        minWidth: 150,
                        width: 150,
                        align: "left",
                    },
                ]);
                setSearchResult(data.map((row, index) => {
                    return {
                        id: row.ticketnr,
                        datum: SftGlobalData.dateFormatter(row.datum),
                        uur: row.uur,
                        mag: row.mag,
                        kassa_id: row.kassa_id,
                        naam: row.naam,
                        firstname: row.firstname,
                        fullRow: row
                    }
                }));
                break;

            case "customers":
                setResultFunc(() => (row) => { if (SftGlobalData.debug) { console.log("row", row); } setKlnr(row.id); setCustomer(row.fullRow); getDeliveryAddress(row.id); setModalOpen(false); })
                setColumns([
                    {
                        field: 'id',
                        headerName: 'ID',
                        minWidth: 50,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'naam',
                        headerName: 'Last name',
                        minWidth: 110,
                        width: 110,
                        align: "left",
                    },
                    {
                        field: 'firstname',
                        headerName: 'First name',
                        minWidth: 110,
                        width: 110,
                        align: "left",
                    },
                    {
                        field: 'firmanaam',
                        headerName: 'Company',
                        minWidth: 110,
                        width: 170,
                        align: "left",
                    },
                    {
                        field: 'adres',
                        headerName: 'Address',
                        minWidth: 150,
                        width: 150,
                        align: "left",
                    },
                    {
                        field: 'postcode',
                        headerName: 'ZIP',
                        minWidth: 75,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'gemeente',
                        headerName: 'City',
                        minWidth: 100,
                        width: 100,
                        align: "left",
                    },
                    {
                        field: 'landcode',
                        headerName: 'Country',
                        minWidth: 75,
                        width: 75,
                        align: "left",
                    },
                    {
                        field: 'gsm',
                        headerName: 'Mobile',
                        minWidth: 150,
                        width: 150,
                        align: "left",
                    },
                    {
                        field: 'email',
                        headerName: 'Email',
                        minWidth: 160,
                        width: 160,
                        align: "left",
                    },
                    {
                        field: 'email2',
                        headerName: 'Email 2',
                        minWidth: 160,
                        width: 160,
                        align: "left",
                    },

                ]);
                setSearchResult(data.map((row, index) => {
                    return {
                        id: row.klnr,
                        naam: row.naam,
                        firstname: row.firstname,
                        firmanaam: row.firmanaam,
                        adres: row.adres,
                        postcode: row.postcode,
                        gemeente: row.gemeente,
                        landcode: row.landcode,
                        gsm: row.gsm,
                        email: row.email,
                        email2: row.email2,
                        fullRow: row
                    }
                }));
                break;
            case "articles":
                setResultFunc(() => (row) => { if (SftGlobalData.debug) { console.log("row", row); } setBarcode(row.id); setArticle(row); setModalOpen(false); })
                const cols = data.length > 0 ? Object.keys(data[0]).map((key,i) => {
                    return {
                        field: key,
                        headerName: key,
                        flex: (i == 0) ? 0.1 : 0.9
                    }
                }) : [];
                setColumns(cols);
                setSearchResult(data.map((row, index) => {
                    return {
                        id: row.barcode,
                        ...row
                    }
                }));
                break;
        }
    }

    const getFileContent = () => {
        switch(selectedFile?.file_type){
            case "TXT":
                return (
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 425, textAlign: 'left'}}>
                        <p>{selectedFile?.file}</p>
                    </div>
                );
            case "IMG":
                return <img alt={selectedFile?.file_name} src={"data:image/jpeg;base64," + selectedFile?.file}  style={{height: "100%", width: "100%", objectFit: "contain", maxHeight: props.maxHeight - 300}} />
            case "PDF":
                return <embed src={"data:application/pdf;base64,"+selectedFile?.file} height="750" style={{width: '100%'}} type="application/pdf"></embed>
            case "VID":
                return (<video width="750" height="750" controls>
                            <source src={"data:video/mp4;base64,"+selectedFile?.file} type={"video/"+filename.split('.').pop()}/>
                            <p>{props.t('video_unsupported')}</p>
                        </video>);
            case "HTML":
                return <iframe title="HTML file" src={"data:text/html,"+selectedFile?.file} height="750" style={{width: '100%'}} />
        }
    }

    const getModalContent = () => {
        return (<div>
            <h2>Search</h2>
            <div className='rowContainerBetween _100perc margin_top_10px margin_bottom_10px'>
                <TextField
                    id="input-with-icon-textfield"
                    autoComplete="off"
                    className={props.theme + '_accent '}
                    sx={{ borderRadius: 3, marginTop: 0 }}
                    size={'small'}
                    fullWidth
                    placeholder={"Search"}
                    value={searchVal}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            search(searchTarget);
                        }
                    }}
                    onChange={(e) => setSearchVal(e.target.value)}
                />
                <Button
                    sx={{ borderRadius: 3, border: '2px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 25, marginLeft: 1 }}
                    variant="outlined"
                    onClick={() => { search(searchTarget); }}
                >
                    <Search />
                </Button>
            </div>
            <DataGridPro
                className={'excel_grid ' + props.theme}
                columns={columns}
                initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns status and traderName, the other columns will remain visible
                        data: false,
                      },
                    },
                  }}
                rows={searchResult}
                rowThreshold={0}
                rowHeight={38}
                loading={searching}
                pagination={true}
                style={{ minHeight: 300, maxHeight: 400 }}
                onRowClick={(params) => { resultFunc(params.row); }}
            />
            {searchTarget === "receipts" && <Button
                sx={{ color: Colors.def_red, width: "100%", marginTop: 1 }}
                variant="outlined"
                onClick={() => { setTicket({}); setTicketNr(""); setTicketDetail([]); setModalOpen(false); }}
            >
                <Delete />
            </Button>}
            <Button
                sx={{ color: Colors.def_red, width: "100%", marginTop: 1 }}
                variant="outlined"
                onClick={() => { setModalOpen(false); }}
            >
                Close
            </Button>
        </div>);
    }
 
    const getStatusModalContent = () => {
        switch (rmaStatus) {
            case "29000":
                return (
                    <div style={{ justifyContent: "flex-end", alignItems: "flex-end", width: "100%", marginTop: 5 }}>
                        {/*<FormControl style={{ width: 540, marginBottom: 20, textAlign: "left" }}>
                            <InputLabel id="demo-simple-select-label">Replacement</InputLabel>
                            <Select
                                id="replacementSelect"
                                label="Replacement"
                                value={replacementId}
                                onChange={(e) => { setReplacementId(e.target.value); setReplacementFrom(dayjs().format("YYYY-MM-DD")); }}  >
                                <MenuItem value="0"><em>None</em></MenuItem>
                                {replacements.map((row, index) => {
                                    return (
                                        <MenuItem value={row.id} key={index}>
                                            <div className=' rowContainerBetween '>
                                                <img alt="Replacement image" src={"data:image/jpeg;base64," + row.image} style={{ objectFit: 'contain', height: 150, width: 150 }} loading={"lazy"} />
                                                <div className=' columnContainerCenter '>
                                                    <p>
                                                        <span className='bold'>{row.name}</span><br />
                                                        {row.type} {row.serial_number} <br />
                                                    </p>
                                                </div>
                                            </div>
                                        </MenuItem>)
                                })}
                            </Select>
                        </FormControl>*/}
                        <Autocomplete
                          style={{ width: 540, marginBottom: 20, textAlign: "left" }}
                          ref={inputRepl}
                          id="replacement-select"
                          className={`${props.theme}_accent log__100_perc margin_right__10px`}
                          label="Replacement"
                          size="small"
                          options={replacements}
                          onChange={(event, value, reason) => {
                            if (reason === "selectOption") {
                              setReplacementId(value?.id);
                              setReplacement(value);
                              setReplacementFrom(dayjs().format("YYYY-MM-DD"));
                            }
                          }}
                          autoHighlight
                          getOptionLabel={(option) => option.name}
                          filterOptions={filterOptions}
                          renderOption={(props, row) => (
                            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                              <div className="rowContainerBetween">
                                <img
                                  alt="Replacement image"
                                  src={"data:image/jpeg;base64," + (row?.image !== "" ? row.image : brokenImage)}
                                  style={{ objectFit: 'contain', height: 150, width: 150, marginRight: 10 }}
                                  loading="lazy"
                                />
                                <div className="columnContainerCenter">
                                  <p>
                                    <span className="bold">{row.name}</span><br />
                                    {row.type} {row.serial_number} <br />
                                  </p>
                                </div>
                              </div>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              inputRef={inputFocus}
                              autoFocus
                              {...params}
                              label="Replacement"
                              inputProps={{
                                ...params.inputProps,
                                // disable autocomplete and autofill
                              }}
                            />
                          )}
                        />
                    </div>
                );
            case "29001":
                return (
                    <div>
                        <p style={{ width: "100%", textAlign: "center" }}><b>Supplier status</b> <br /><br />{getSupplierStatus(supplierStatus)}<br /><br /></p>
                    </div>
                );
        }
    }

    const handleStatusChange = () => {
        switch (rmaStatus) {
            case "29000": // OPEN
                if (replacementId != "0"){
                    setValue(1);
                    setReplacementFrom(dayjs().format('YYYY-MM-DD'));
                }
                setStatusModal(false);
                return "29001";
            case "29001": // ARTICLE RECEIVED
                setStatusModal(false);
                return "29003";
            case "29003": // ARTICLE RETURNING
                setStatusModal(false);
                return "29004";
            case "29004": // REPLACEMENT RETURNING
                if (replacementId != "0"){
                    setReplacementUntil(dayjs().format('YYYY-MM-DD'));
                }
                setStatusModal(false);
                return "29002";
            default:
                setStatusModal(false);
                return "29000";
        }
    }

    const handleSupplierStatusChange = () => {
        if(supplierStatus == "29505")
            return "29505";
        let temp = supplierStatus;
        temp = parseInt(temp) + 1;
        temp = temp + "";

        setSupplierStatusModal(false);
        return temp;
    }

    const getNextStatus = () => {
        switch (rmaStatus) {
            case "29000": // OPEN
                return getRmaStatus("29001");
            case "29001": // ARTICLE RECEIVED
                return getRmaStatus("29003");
            case "29003": // ARTICLE RETURNING
                return getRmaStatus("29004");
            case "29004": // REPLACEMENT RETURNING
                return getRmaStatus("29002");
            default:
                return getRmaStatus("29000");
        }
    }

    const getNextSupplierStatus = () => {
        if(supplierStatus == "29505")
            return getSupplierStatus("29505");
        let temp = supplierStatus;
        temp = parseInt(temp) + 1;
        temp = temp + "";
        return getSupplierStatus(temp);
    }

    function onFileChange(e) {
        let files = e.target.files;
        let fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
 
        fileReader.onload = (event) => {
            setFile(event.target.result.replace(/^data:image\/[a-zA-Z]+;base64,/, '').replace(/^data:application\/[a-zA-Z]+;base64,/, ''));
        }
        //console.log("DEBUG", inputFile.current.files[0].name);

        setFilename(inputFile.current.files[0].name);
    }

    const filterOptions = (options, state) => {
        const inputValue = state.inputValue.toLowerCase();
        return options.filter(option => {
          return (
            option.name.toLowerCase().includes(inputValue) ||
            option.serial_number.toLowerCase().includes(inputValue) ||
            option.type.toLowerCase().includes(inputValue) ||
            option.remark.toLowerCase().includes(inputValue)
          );
        });
      };

    const skeletonAnim = "wave";

    const handleCellClick = (params, event) => {
        if (event.target.closest(".exclude-row-click")) {
            event.stopPropagation();
        }
    };

    return (
        <div className={props.hideSidebar ? "" : "expanded container_content"} style={{ width: '100%', textAlign: 'start', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column', marginTop: 5, marginBottom: 30 }}>
            {!props.hideSidebar && <FloatingBackButton disabled={false} onClick={() => { navigate("/" + props.lang + "/rma"); }} />}
            <FloatingSaveButton disabled={loading} onClick={() => { onSave(); }} />
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalFile}
                onClose={()=>{setModalFile(false);}}
                BackdropComponent={Backdrop}
                >
                <Box sx={style} style={{minWidth: 500, minHeight: 500}} className={props.theme + " _50perc"}>
                    <h2>{selectedFile?.file_name}</h2>
                    <div>
                        {getFileContent()}
                    </div>
                </Box>
            </StyledModal>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalHistoryRec}
                onClose={() => { setModalHistoryRec(false); }}
                BackdropComponent={Backdrop}
            >
                <Box sx={style} style={{ width: 650 }} className={props.theme}>
                    <h2>{historyRec?.created_at} ({historyRec?.user_update})</h2>
                    <hr/>
                    <div className='columnContainerStart _100perc'>
                        <div className='rowContainerBetween'><span className='bold'>RMA status:</span> <span>{getRmaStatus(historyRec?.rma_status)}</span></div>
                        <div className='rowContainerBetween'><span className='bold'>Supplier status:</span> <span>{getSupplierStatus(historyRec?.supplier_status)}</span></div>
                        <div className='rowContainerBetween'><span className='bold'>Supplier RMA ID:</span> <span>{historyRec?.supplier_rma_id}</span></div>
                        <div className='rowContainerBetween'><span className='bold'>Replacement:</span> <span>{historyRec?.replacement_name}</span></div>
                        <div className='rowContainerBetween'><span className='bold'>Assigned to:</span> <span>{historyRec?.assigned_user}</span></div>
                    </div>
                    <br/>
                    <p>{historyRec?.rma_remark}</p>
                    <br/>
                    <em>{historyRec?.remark}</em>
                    <br/>
                    <br/>
                </Box>
            </StyledModal>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalHistoryAdd}
                onClose={() => { setModalHistoryAdd(false); }}
                BackdropComponent={Backdrop}
            >
                <Box sx={style} style={{ width: 500 }} className={props.theme}>
                    <h2>History - Add record</h2>
                    <hr/>
                    <div className='columnContainerBetween'>
                        <div className='rowContainerBetween' style={{ justifyContent: "flex-start", alignItems: "flex-start", textAlign: "left", marginBottom: 10 }}>
                            <TextField
                                multiline
                                minRows={5}
                                maxRows={5}
                                autoComplete="off"
                                className={props.theme + '_accent '}
                                id="remark"
                                label={props.t('remark')}
                                size={'small'}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }, borderRadius: 3, marginTop: 0
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }, borderRadius: 3, marginTop: 0
                                    }}
                                style={{width: "100%", marginBottom: 5}}
                                value={statusRemark}
                                onChange={(event) => { setStatusRemark(event.target.value) }}
                            />
                        </div>
                        <Button className={"modal_button_container_no_margin__button margin_top_5px"} style={{width: "100%", marginBottom: 5}} onClick={() => { updateStatus(); setModalHistoryAdd(false);  }}> Add record </Button>
                    </div>
                </Box>
            </StyledModal>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalOpen}
                onClose={() => { setModalOpen(false); }}
                BackdropComponent={Backdrop}
            >
                <Box sx={style} style={{ minWidth: 500, minHeight: 590 }} className={props.theme + " _80perc"}>
                    {getModalContent()}
                </Box>
            </StyledModal>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={statusModal}
                onClose={() => { setStatusModal(false); }}
                BackdropComponent={Backdrop}
            >
                <Box sx={style} style={{ minWidth: 500, maxWidth: 600, minHeight: 590, width: "80%", alignItems: "" }} className={props.theme + " _80perc columnContainerBetween"}>
                    <h2>Change RMA status -&gt; {getNextStatus()}</h2>
                    <div className='rowContainerBetween' style={{ justifyContent: "flex-start", alignItems: "flex-start", textAlign: "left" }}>
                        <TextField
                            multiline
                            minRows={5}
                            maxRows={5}
                            autoComplete="off"
                            className={props.theme + '_accent '}
                            id="remark"
                            label={props.t('remark')}
                            size={'small'}
                            sx={(props.theme === 'light') ? {
                                '& .MuiOutlinedInput-input': {
                                    color: Colors.light_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.light_text
                                }, borderRadius: 3, marginTop: 0
                            }
                                :
                                {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.dark_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.dark_text_accent
                                    }, borderRadius: 3, marginTop: 0
                                }}
                            style={{width: 540, minWidth: 540, maxWidth: 540, marginBottom: 5}}
                            value={statusRemark}
                            onChange={(event) => { setStatusRemark(event.target.value) }}
                        />
                    </div>
                    {getStatusModalContent()}
                    <Button className={"modal_button_container_no_margin__button margin_top_5px"} style={{width: 540, minWidth: 540, maxWidth: 540, marginBottom: 5}} onClick={() => { setRmaStatus(handleStatusChange()); }}> Change the status </Button>
                </Box>
            </StyledModal>

            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={supplierStatusModal}
                onClose={() => { setSupplierStatusModal(false); }}
                BackdropComponent={Backdrop}
            >
                <Box sx={style} style={{ minWidth: 500, maxWidth: 600, minHeight: 590, width: "80%", alignItems: "" }} className={props.theme + " _80perc columnContainerBetween"}>
                    <h2>Change supplier status -&gt; {getNextSupplierStatus()}</h2>
                    <div className='rowContainerStart' style={{ justifyContent: "flex-start", alignItems: "flex-start", textAlign: "left" }}>
                        <TextField
                            multiline
                            minRows={5}
                            maxRows={5}
                            autoComplete="off"
                            className={props.theme + '_accent '}
                            id="remark"
                            label={props.t('remark')}
                            size={'small'}
                            sx={(props.theme === 'light') ? {
                                '& .MuiOutlinedInput-input': {
                                    color: Colors.light_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.light_text
                                }, borderRadius: 3, marginTop: 0
                            }
                                :
                                {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.dark_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.dark_text_accent
                                    }, borderRadius: 3, marginTop: 0
                                }}
                            style={{width: 540, minWidth: 540, maxWidth: 540, marginBottom: 5}}
                            value={statusRemark}
                            onChange={(event) => { setStatusRemark(event.target.value) }}
                        />
                    </div>
                    <div>
                        <Button className={"modal_button_container_no_margin__button margin_top_5px"} style={{width: 540, minWidth: 540, maxWidth: 540, marginBottom: 5}} onClick={() => { setSupplierStatus(handleSupplierStatusChange()); }}> Change the status </Button>
                        <Button className={"modal_button_container_no_margin__button margin_top_5px"} style={{width: 540, minWidth: 540, maxWidth: 540, marginBottom: 5}} onClick={() => { setSupplierStatus("29505"); setSupplierStatusModal(false); }}> Close the supplier status </Button>
                    </div>
                    
                </Box>
            </StyledModal>

            
            
            <div className='rowContainerCenter _100perc'>
                <div className={" log__flex_add "} style={{ height: "100%" }}>
                    <div className={props.theme + " rma_content_block box_fade-in log__margin_left_small"} style={{ height: props.maxHeight - 160, overflow: "auto", width: "100%" }}>
                        {loading && (<Box style={{width: "100%"}}>
                            <div className='rowContainerStart'>
                                <Skeleton animation={skeletonAnim} style={{width: "100%", height: 100, marginRight: 10}} />
                                <Skeleton animation={skeletonAnim} sx={{ borderRadius: 3, width: 65 }} style={{marginRight: 10}} />
                            </div>
                            <div className='rowContainerStart'>
                                <Skeleton animation={skeletonAnim} style={{width: 120, height: 60, marginRight: 10}}/>
                                <Skeleton animation={skeletonAnim} style={{width: 120, height: 60, marginRight: 10}}/>
                                <Skeleton animation={skeletonAnim} style={{width: 120, height: 60, marginRight: 10}}/>
                                <Skeleton animation={skeletonAnim} style={{width: 120, height: 60, marginRight: 10}}/>
                                <Skeleton animation={skeletonAnim} style={{width: 120, height: 60, marginRight: 10}}/>
                            </div>
                            <Skeleton animation={skeletonAnim} style={{width: "100%", height: 3, marginRight: 10, marginTop: -8}} />


                            <div style={{ paddingTop: 15 }} className='rowContainerBetween'>
                                <div style={{ width: "75%" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 39, marginRight: 15 }}>
                                        <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                        <Skeleton animation={skeletonAnim} sx={{ width: 50, marginLeft: 1, height: 65 }}/>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 39, marginRight: 15 }}>
                                        <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                        <Skeleton animation={skeletonAnim} sx={{ width: 50, marginLeft: 1, height: 65 }}/>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 39, marginRight: 15 }}>
                                        <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginLeft: 39, marginRight: 15 }}>
                                        <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                        <Skeleton animation={skeletonAnim} sx={{ width: 50, marginLeft: 1, height: 65 }}/>
                                    </div>
                                </div>
                                <div className='columnContainerBetween ' style={{ borderLeft: (Colors.def_grey + " solid 1px"), textAlign: "center", width: "24%", paddingLeft: 10, paddingRight: 10 }}>
                                    <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                    <Skeleton animation={skeletonAnim} style={{width: "100%", height: 100}}/>
                                    <Skeleton animation={skeletonAnim} style={{width: "100%", height: 65}}/>
                                </div>
                            </div>
                        </Box>)}
                        {!loading && <div className='rowContainerBetween' style={{width: "100%", marginTop: 10}}>
                            <TextField
                                multiline
                                minRows={2}
                                maxRows={2}
                                autoComplete="off"
                                className={props.theme + '_accent '}
                                id="remark"
                                label={"RMA " + (params.rmaId === "add" ? " - " : params.rmaId)}
                                size={'small'}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }, borderRadius: 3, marginTop: 0
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }, borderRadius: 3, marginTop: 0
                                    }}
                                style={{width: "100%"}}
                                value={remark}
                                onChange={(event) => { setRemark(event.target.value) }}
                            />
                            <Button
                                sx={{ borderRadius: 3, border: '2px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 25, marginLeft: 1 }}
                                variant="outlined"
                                onClick={() => { setModalHistoryAdd(true); }}
                                disabled={typeof params.rmaId === "undefined" || params.rmaId === "" || params.rmaId === "add"}
                            >
                                <History />
                            </Button>
                        </div>}


                        {!loading && <Box className={' licence__enivronment'} style={{ width: "100%", marginLeft: 0 }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                                <Tabs value={value} onChange={(event, newValue) => { setValue(newValue) }} className={props.theme} variant="scrollable" scrollButtons="auto">
                                    <Tab label={"RMA "} {...a11yProps(0)} className={props.theme} />
                                    <Tab label={"REPLACEMENT "} {...a11yProps(1)} className={props.theme + (replacementId != "0" ? " bold " : "")} />
                                    <Tab label={"SUPPLIER "} {...a11yProps(2)} className={props.theme} />
                                    {params.rmaId !== "add" &&<Tab label={"HISTORY "} {...a11yProps(3)} className={props.theme} />}
                                    {params.rmaId !== "add" &&<Tab label={"FILES "} {...a11yProps(4)} className={props.theme} />}
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                <div style={{ width: "75%" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flex: 1, marginBottom: 10, marginLeft: 39, marginRight: 15 }}>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            autoComplete="off"
                                            className={props.theme + '_accent '}
                                            sx={{ borderRadius: 3, marginTop: 0 }}
                                            size={'small'}
                                            fullWidth
                                            placeholder={"ReceiptId"}
                                            disabled={true}
                                            value={ticketNr + " (" + store + ")"}
                                            label="Kasticket nr"
                                            //onChange={(e) => setTicketNr(e.target.value)}
                                        />
                                        <Button
                                            sx={{ borderRadius: 3, border: '2px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 25, marginLeft: 1 }}
                                            variant="outlined"
                                            onClick={() => { setSearchVal(ticketNr); setSearchTarget("receipts"); setSearchResult([]); setModalOpen(true); }}
                                        >
                                            <Search />
                                        </Button>
                                    </div>
                                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
                                                <TextField
                                                    id="input-with-icon-textfield"
                                                    autoComplete="off"
                                                    label={props.t('customer')}
                                                    className={props.theme + '_accent '}
                                                    sx={{ borderRadius: 3, marginTop: 0 }}
                                                    size={'small'}
                                                    fullWidth
                                                    placeholder={props.t('customer_id')}
                                                    disabled={true}
                                                    value={"" + (klnr != 0  ? (klnr + " - " + customer?.naam + " " + customer?.firstname + (customer?.firmanaam !== "" ? (" ("+customer?.firmanaam+")"):"")) : "")}
                                                    onChange={(e) => setKlnr(e.target.value)}
                                                    autoFocus={true}
                                                />
                                                <Button
                                                    sx={{ borderRadius: 3, border: '2px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 25, marginLeft: 1 }}
                                                    variant="outlined"
                                                    onClick={() => { setSearchVal((customer?.firmanaam !== "" ? customer?.firmanaam : "")); setSearchTarget("customers"); setSearchResult([]); setModalOpen(true); }}
                                                    disabled={ticketNr !== "" && ticketNr != 0}
                                                >
                                                    <Search />
                                                </Button>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                {(klnr !== "" && klnr != "0") && <table >
                                                    <tbody>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>First name</td>
                                                            <td>{customer?.firstname}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Last name</td>
                                                            <td>{customer?.naam}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Company</td>
                                                            <td>{customer?.firmanaam}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Address</td>
                                                            <td>{customer?.adres} <br /> {customer?.postcode} {customer?.gemeente}<br />{customer?.landcode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Mobile</td>
                                                            <td>{customer?.gsm}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Email</td>
                                                            <td>{customer?.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Email2</td>
                                                            <td>{customer?.email2}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Divers</td>
                                                            <td>{customer?.divers}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>}
                                                {(klnr === "" || klnr == "0") && <span className='bold'> No customer data to show...</span>}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    {deliveryAddresses.length > 0 && <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
                                                <FormControl style={{ width: '100%' }}>
                                                    <InputLabel id="demo-simple-select-label-kldeid">Delivery address</InputLabel>
                                                    <Select id="kldeselect" labelId="demo-simple-select-label-kldeid" label="Delivery address" value={kldeId} onChange={(e) => { setKldeId(e.target.value) }} style={{ maxHeight: 43 }}
                                                        renderValue={(selected) => {
                                                            if (selected == "0")
                                                                return " - ";
                                                            const selectedOption = deliveryAddresses.find(option => option.klde_id == selected);
                                                            return selectedOption ? (selectedOption.klde_id + ' - ' + selectedOption.klde_naam1) : '';
                                                        }}>
                                                        <MenuItem value="0"><em>None</em></MenuItem>
                                                        {deliveryAddresses.map((row, index) => {
                                                            return (
                                                                <MenuItem value={row.klde_id} key={index}>
                                                                    <ListItemText
                                                                        primary={row.klde_naam1}
                                                                        secondary={<div>
                                                                            <p>{row.klde_adres1}<br />
                                                                                {row.klde_adres2 != "" && <span>{row.klde_adres2}<br /></span>}
                                                                                {row.klde_postcode} {row.klde_gemeente} {row.klde_landcode}<br />
                                                                                {row.klde_email}<br />
                                                                                {row.klde_gsm}</p>
                                                                        </div>}
                                                                    />
                                                                </MenuItem>)
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                {(kldeId != "0" && kldeId !== "") && <table >
                                                    <tbody>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Name 1</td>
                                                            <td>{deliveryAddress?.klde_naam1}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Name 2</td>
                                                            <td>{deliveryAddress?.klde_naam2}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Address</td>
                                                            <td>{deliveryAddress?.klde_adres1} {deliveryAddress?.klde_adres2} <br /> {deliveryAddress?.klde_postcode} {deliveryAddress?.klde_gemeente}<br />{deliveryAddress?.klde_landcode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Mobile</td>
                                                            <td>{deliveryAddress?.klde_gsm}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Email</td>
                                                            <td>{deliveryAddress?.klde_email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Divers</td>
                                                            <td>{deliveryAddress?.klde_divers}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>}
                                                {(kldeId == "0" || kldeId === "") && <span className='bold'>No Delivery address data to show...</span>}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>}
                                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                            {ticketDetail.length === 0 && <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
                                                <TextField
                                                    id="input-with-icon-textfield"
                                                    autoComplete="off"
                                                    className={props.theme + '_accent '}
                                                    sx={{ borderRadius: 3, marginTop: 0 }}
                                                    size={'small'}
                                                    label="Article"
                                                    fullWidth
                                                    placeholder={"Barcode"}
                                                    disabled={true}
                                                    value={(typeof article?.article !== "undefined" && typeof article?.article !== "object") ? article?.article : barcode}
                                                    onChange={(e) => {if(SftGlobalData.debug) console.log("debug", e.target.value);}}
                                                />
                                                <Button
                                                    sx={{ borderRadius: 3, border: '2px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 25, marginLeft: 1 }}
                                                    variant="outlined"
                                                    onClick={() => { setSearchVal(barcode); setSearchTarget("articles"); setSearchResult([]); setModalOpen(true); }}
                                                >
                                                    <Search />
                                                </Button>
                                            </div>}
                                            {ticketDetail.length > 0 && <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
                                                <FormControl style={{ width: '100%' }}>
                                                    <InputLabel id="demo-simple-select-label-art">Article</InputLabel>
                                                    <Select id="barcselect" labelId="demo-simple-select-label-art" label="Article" value={barcode} onChange={(e) => {
                                                        const selectedOption = ticketDetail.find(option => option.barcode == e.target.value);
                                                        setArticle({data: selectedOption, article: ""});
                                                        setBarcode(e.target.value);
                                                    }} style={{ maxHeight: 43 }}
                                                        renderValue={(selected) => {
                                                            if (selected == "0")
                                                                return " - ";
                                                            const selectedOption = ticketDetail.find(option => option.barcode == selected);
                                                            return selectedOption ? (selectedOption.oms) : '';
                                                        }}>
                                                        {ticketDetail.map((row, index) => {
                                                            return (
                                                                <MenuItem value={row.barcode} name={row} key={index}>
                                                                    <ListItemText
                                                                        primary={row.oms}
                                                                        secondary={<span>{row.barcode}</span>}
                                                                    />
                                                                </MenuItem>)
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                {barcode !== "" && <table >
                                                    <tbody>
                                                        {article?.data?.barc_edi !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>EDI</td>
                                                            <td>{article?.data?.barc_edi}</td>
                                                        </tr>}
                                                        {article?.data?.levart1 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Detail 1</td>
                                                            <td>{article?.data?.levart1}</td>
                                                        </tr>}
                                                        {article?.data?.levart2 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Detail 2</td>
                                                            <td>{article?.data?.levart2}</td>
                                                        </tr>}
                                                        {article?.data?.levart3 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Detail 3</td>
                                                            <td>{article?.data?.levart3}</td>
                                                        </tr>}
                                                        {article?.levart4 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Detail 4</td>
                                                            <td>{article?.data?.levart4}</td>
                                                        </tr>}
                                                        {article?.data?.levart5 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Detail 5</td>
                                                            <td>{article?.data?.levart5}</td>
                                                        </tr>}
                                                        {article?.data?.oms1 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Descr. 1</td>
                                                            <td>{article?.data?.oms1}</td>
                                                        </tr>}
                                                        {article?.data?.oms2 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Descr. 2</td>
                                                            <td>{article?.data?.oms2}</td>
                                                        </tr>}
                                                        {article?.data?.oms3 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Descr. 3</td>
                                                            <td>{article?.data?.oms3}</td>
                                                        </tr>}
                                                        {article?.data?.oms4 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Descr. 4</td>
                                                            <td>{article?.data?.oms4}</td>
                                                        </tr>}
                                                        {article?.data?.oms5 !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Descr. 5</td>
                                                            <td>{article?.data?.oms5}</td>
                                                        </tr>}
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Color</td>
                                                            <td>{article?.data?.kleurlev}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='bold table_rma_head_width'>Size</td>
                                                            <td>{article?.data?.mtomsX + (article?.data?.mtomsY !== "" ? (" / " + article?.data?.mtomsX) : "")} </td>
                                                        </tr>
                                                        {article?.data?.seizoen !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Season</td>
                                                            <td>{article?.seizoen}</td>
                                                        </tr>}
                                                        {article?.data?.levnr !== "" && <tr>
                                                            <td className='bold table_rma_head_width'>Supplier</td>
                                                            <td>{article?.data?.levnr}</td>
                                                        </tr>}
                                                    </tbody>
                                                </table>}
                                                {(barcode === "") && <span className='bold'>No article data to show...</span>}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                <div className='columnContainerBetween ' style={{ borderLeft: (Colors.def_grey + " solid 1px"), textAlign: "center", width: "24%", paddingLeft: 10, paddingRight: 10 }}>
                                    <FormControl style={{ width: "100%", textAlign: "left"}}>
                                        <InputLabel id="demo-simple-select-label-userSelect">Assigned to</InputLabel>
                                        <Select id="userSelect" labelId="demo-simple-select-label-userSelect" label="Assigned to" value={assignedUserId} onChange={(e) => { setAssignedUserId(e.target.value) }} style={{ maxHeight: 43 }}>
                                            <MenuItem value="0"><em>None</em></MenuItem>
                                            {users.map(user => {return (<MenuItem key={user.userid} value={user.userid}>{user.naam} ({user.userid})</MenuItem>);})}
                                        </Select>
                                    </FormControl>
                                    {getRmaStatus(rmaStatus)}
                                    {(rmaStatus != "29002" && klnr !== "" && article !== "" && params.rmaId !== "add") && <Button
                                        className={" margin_top_5px small_margin_bottom "}
                                        sx={{ borderRadius: 2, border: '1px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: "100%", marginBottom: 5 }}
                                        variant="outlined"
                                        onClick={() => { if(rmaStatus != "29000" && (supplierStatus != "29500" && supplierStatus != "29505")) setValue(2); else setStatusModal(true); }}
                                        disabled={(klnr === "" || article === "" || params.rmaId === "add")}
                                    > {getNextStatus()}</Button>}
                                    {(rmaStatus == "29002" || klnr === "" || article === "" || params.rmaId === "add") && <div></div>}
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <div>
                                    {replacementId != "0" && <div className=' rowContainerBetween '>
                                                            <img alt="Replacement image" src={"data:image/jpeg;base64," + (replacement?.image !== "" ? replacement.image : brokenImage)} style={{ objectFit: 'contain', height: 150, width: 150, marginRight: 10 }} loading={"lazy"} />
                                                            <div className=' columnContainerCenter '>
                                                                <p>
                                                                    <span className='bold'>{replacement.name}</span><br />
                                                                    {replacement.type} {replacement.serial_number} <br />
                                                                </p>
                                                            </div>
                                                        </div>}
                                    {/*<FormControl style={{ width: 540, marginBottom: 20 }}>
                                        <InputLabel id="demo-simple-select-label">Replacement</InputLabel>
                                        <Select
                                            id="replacementSelect"
                                            label="Replacement"
                                            value={replacementId}
                                            onChange={(e) => { setReplacementId(e.target.value); setReplacementFrom(dayjs().format("YYYY-MM-DD")); }}  >
                                            <MenuItem value="0"><em>None</em></MenuItem>
                                            {replacements.map((row, index) => {
                                                return (
                                                    <MenuItem value={row.id} key={index}>
                                                        <div className=' rowContainerBetween '>
                                                            <img alt="Replacement image" src={"data:image/jpeg;base64," + (row?.image !== "" ? row.image : brokenImage)} style={{ objectFit: 'contain', height: 150, width: 150, marginRight: 10 }} loading={"lazy"} />
                                                            <div className=' columnContainerCenter '>
                                                                <p>
                                                                    <span className='bold'>{row.name}</span><br />
                                                                    {row.type} {row.serial_number} <br />
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </MenuItem>)
                                            })}
                                        </Select>
                                    </FormControl> */}
                                    <br />
                                    <Autocomplete
                                      style={{ width: 540, marginBottom: 20 }}
                                      ref={inputRepl}
                                      id="replacement-select"
                                      className={`${props.theme}_accent log__100_perc margin_right__10px`}
                                      label="Replacement"
                                      size="small"
                                      options={replacements}
                                      onChange={(event, value, reason) => {
                                        if (reason === "selectOption") {
                                          setReplacementId(value?.id);
                                          setReplacement(value);
                                          setReplacementFrom(dayjs().format("YYYY-MM-DD"));
                                        }
                                      }}
                                      autoHighlight
                                      getOptionLabel={(option) => option.name}
                                      filterOptions={filterOptions}
                                      renderOption={(props, row) => (
                                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                          <div className="rowContainerBetween">
                                            <img
                                              alt="Replacement image"
                                              src={"data:image/jpeg;base64," + (row?.image !== "" ? row.image : brokenImage)}
                                              style={{ objectFit: 'contain', height: 150, width: 150, marginRight: 10 }}
                                              loading="lazy"
                                            />
                                            <div className="columnContainerCenter">
                                              <p>
                                                <span className="bold">{row.name}</span><br />
                                                {row.type} {row.serial_number} <br />
                                              </p>
                                            </div>
                                          </div>
                                        </Box>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          inputRef={inputFocus}
                                          autoFocus
                                          {...params}
                                          label="Replacement"
                                          inputProps={{
                                            ...params.inputProps,
                                            // disable autocomplete and autofill
                                          }}
                                        />
                                      )}
                                    />
                                    <div className='rowContainerBetween'>
                                        <DatePicker
                                            label="Replacement from date"
                                            format="DD/MM/YYYY"
                                            value={dayjs(replacementFrom)}
                                            onChange={(newValue) => setReplacementFrom(dayjs(newValue).format("YYYY-MM-DD"))}

                                            className=' margin_right__10px margin_bottom_10px '
                                        />
                                        <DatePicker
                                            label="Replacement until date"
                                            format="DD/MM/YYYY"
                                            value={dayjs(replacementUntil)}
                                            disabled={true}
                                            onChange={(newValue) => setReplacementUntil(dayjs(newValue).format("YYYY-MM-DD"))}

                                            className=' margin_bottom_10px '
                                        />
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <div>
                                    <p style={{ width: 540, textAlign: "center", marginTop: 10, marginBottom: 10 }}><b>Supplier status</b> <br /><br />{getSupplierStatus(supplierStatus)}<br /><br /></p>
                                    <Button
                                        sx={{ borderRadius: 2, border: '1px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: 540, marginBottom: 5 }}
                                        variant="outlined"
                                        onClick={() => { if(supplierStatus == "29505") setValue(0); else setSupplierStatusModal(true); }}
                                    >
                                        {getNextSupplierStatus()}
                                    </Button><br />
                                    <TextField
                                        className={props.theme + '_accent margin_right__10px margin_bottom_10px'}
                                        label="Serial number"
                                        value={serialNumber}
                                        onChange={(event) => {
                                            setSerialNumber(event.target.value);
                                        }}
                                        variant="outlined"
                                        style={{ height: 43, width: 265 }}
                                        sx={(props.theme === 'light') ? {
                                            '& .MuiOutlinedInput-input': {
                                                color: Colors.light_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.sft_blue
                                            }
                                        }
                                            :
                                            {
                                                '& .MuiOutlinedInput-input': {
                                                    color: Colors.dark_text
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: Colors.sft_blue
                                                }
                                            }}
                                    />
                                    <DatePicker
                                        label="Warranty valid until"
                                        format="DD/MM/YYYY"
                                        value={dayjs(warrantyUntil)}
                                        onChange={(newValue) => setWarrantyUntil(dayjs(newValue).format("YYYY-MM-DD"))}

                                        className=' margin_right__10px margin_bottom_10px '
                                    />
                                    <br />
                                    <TextField
                                        className={props.theme + '_accent margin_bottom_10px'}
                                        label="Supplier RMA ID"
                                        value={supplierRmaId}
                                        onChange={(event) => {
                                            setSupplierRmaId(event.target.value);
                                        }}
                                        variant="outlined"
                                        style={{ height: 43, width: 540 }}
                                        sx={(props.theme === 'light') ? {
                                            '& .MuiOutlinedInput-input': {
                                                color: Colors.light_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.sft_blue
                                            }
                                        }
                                            :
                                            {
                                                '& .MuiOutlinedInput-input': {
                                                    color: Colors.dark_text
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: Colors.sft_blue
                                                }
                                            }}
                                    />
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <div className='rowContainerCenter _100perc' style={{maxHeight: 500, width: "100%"}}>
                                    <DataGridPro
                                          //apiRef={apiRef}
                                          initialState={{
                                            columns: {
                                              columnVisibilityModel: {
                                                // Hide columns status and traderName, the other columns will remain visible
                                                id: false,
                                              },
                                            },
                                          }}
                                          className={'excel_grid ' + props.theme}
                                          columns={[
                                            {
                                                field: 'id',
                                                headerName: 'ID',
                                                minWidth: 50,
                                                maxWidth: 50,
                                                width: 50,
                                                align: "left",
                                            },
                                            {
                                                field: 'created_at',
                                                headerName: "Created at",
                                                minWidth: 165,
                                                align: "left",
                                            },
                                            {
                                                field: 'rma_status',
                                                headerName: "Status",
                                                minWidth: 100,
                                                align: "left",
                                                renderCell: (params)=>{return (getRmaStatus(params.row.rma_status))}
                                            },
                                            {
                                                field: 'supplier_status',
                                                headerName: "Supplier status",
                                                minWidth: 120,
                                                align: "left",
                                                renderCell: (params)=>{return (getSupplierStatus(params.row.supplier_status))},
                                            },
                                            {
                                                field: 'supplier_rma_id',
                                                headerName: "Supplier RMA",
                                                minWidth: 100,
                                                align: "left",
                                            },
                                            {
                                                field: 'replacement_name',
                                                headerName: "Replacement",
                                                minWidth: 150,
                                                align: "left",
                                            },
                                            {
                                                field: 'remark',
                                                headerName: "Remark",
                                                minWidth: 350,
                                                align: "left",
                                            },
                                            {
                                                field: 'rma_remark',
                                                headerName: "RMA remark",
                                                minWidth: 350,
                                                align: "left",
                                            },
                                            {
                                                field: 'user_update',
                                                headerName: "Update by",
                                                minWidth: 150,
                                                align: "left",
                                            },
                                            {
                                                field: 'assigned_user',
                                                headerName: "Assigned to",
                                                minWidth: 150,
                                                align: "left",
                                            },
                                          ]}
                                          rows={history.map((row, index) => {return row;})} 
                                          rowThreshold={0}
                                          rowHeight={38}
                                          onRowClick={(params) => {setHistoryRec(params.row); setModalHistoryRec(true);}}
                                          loading={loading}
                                          pagination={true}
                                          style={{minHeight: 300}}
                                    /> 
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <div className='rowContainerCenter _100perc' style={{maxHeight: 500, width: "70%"}}>
                                    <DataGridPro
                                        className={'excel_grid ' + props.theme}
                                        initialState={{
                                            columns: {
                                              columnVisibilityModel: {
                                                // Hide columns status and traderName, the other columns will remain visible
                                                id: false,
                                              },
                                            },
                                        }}
                                        columns={[
                                            {
                                                field: 'id',
                                                headerName: 'ID',
                                                minWidth: 50,
                                                maxWidth: 50,
                                                width: 50,
                                                align: "left",
                                                display: 'flex',      
                                            },
                                            {
                                                field: 'created_at',
                                                headerName: "Created at",
                                                minWidth: 165,
                                                align: "left",
                                                display: 'flex',      
                                            },
                                            {
                                                field: 'user_name',
                                                headerName: "Created by",
                                                minWidth: 150,
                                                align: "left",
                                                display: 'flex',      
                                            },
                                            {
                                                field: 'file_name',
                                                headerName: "File",
                                                minWidth: 150,
                                                align: "left",
                                                display: 'flex',      
                                            },
                                            {
                                                field: 'file_type',
                                                headerName: "Type",
                                                minWidth: 75,
                                                align: "left",
                                                display: 'flex',      
                                                renderCell: (params)=>{
                                                    switch(params.row.file_type){
                                                        case "TXT":
                                                            return <TextSnippetIcon  style={{color: Colors.def_red}}/>
                                                        case "IMG":
                                                            return <ImageIcon style={{color: Colors.def_red}}/>
                                                        case "VID":
                                                            return <OndemandVideoIcon style={{color: Colors.def_red}}/>
                                                        case "PDF":
                                                            return <PictureAsPdfIcon style={{color: Colors.def_red}}/>
                                                        case "HTML":
                                                            return <HtmlIcon style={{color: Colors.def_red}}/>
                                                        default:
                                                            return <DownloadIcon style={{color: Colors.def_red}}/>
                                                    }
                                                }
                                            },
                                            {
                                                field: 'delete',
                                                headerName: 'Delete',
                                                minWidth: 60,    
                                                maxWidth: 100,  
                                                align: 'center',      
                                                headerAlign: 'center', 
                                                display: 'flex',      
                                                renderCell: (params) => {
                                                    return ((params.row.pos_id !== "0000" || params.row.store_id !== "00" || ((props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") && params.row.listSize === 1))) ? 
                                                    <Button style={{ color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height: "100%", borderRadius: "50%" }} onClick={() => { onDeleteFile(params.row.id) }} className="exclude-row-click">
                                                        <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                                                    </Button> : <div></div>;
                                                }
                                            },
                                        ]}
                                        //onRowClick={(row)=>{handleRowClicked(row.row.file_type, row.row.filename);}}
                                        rows={files.map((row, index) => {return {
                                                id: row.id,
                                                file_name: row.file_name,
                                                file_type: row.file_type,
                                                created_at: row.created_at,
                                                user_name: row.user_name,
                                                file: row.file,
                                            }
                                        })}
                                          rowThreshold={0}
                                          rowHeight={38}
                                          onRowClick={(params) => {setSelectedFile(params.row); setModalFile(true);}}
                                          onCellClick={handleCellClick}
                                          loading={loading}
                                          pagination={true}
                                          style={{minHeight: 300}}
                                    />
                                </div>
                                <div className='columnContainerBetween' style={{width: "28%", maxHeight: 300}}>
                                    <h2 style={{textAlign: "center", marginBottom: 5, marginTop: 0}}>{props.t('add')}</h2>
                                    <div className=' log__100_perc '>
                                        <label className="text-white">{props.t('select_file')}</label>
                                        <input type="file" ref={inputFile} className="form-control" name="File" onChange={onFileChange} style={{width: '100%'}} />
                                    </div>
                                    <Button
                                        className={" small_margin_bottom "}
                                        sx={{ borderRadius: 2, border: '1px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: "100%", marginBottom: 5 }}
                                        variant="outlined"
                                        onClick={() => { uploadFile(); }}
                                    >
                                        Upload
                                    </Button>
                                </div>
                            </TabPanel>
                        </Box>}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default RMADetailScreen;